// Shipping & Returns — public-facing policy. Combined page (standard for small
// shops). All rates and windows reflect the 2026 Square storefront setup.

import PolicyPage from "./PolicyPage";

export default function ShippingPolicy() {
  return (
    <PolicyPage title="Shipping & Returns" lastUpdated="April 16, 2026">
      <h2>Shipping rates</h2>
      <p>
        Flat-rate shipping, built to be simple. No surprise calculated rates at checkout.
      </p>
      <ul>
        <li><strong>United States:</strong> $6.50 per order. Ships via USPS Ground Advantage. Delivery 2–5 business days.</li>
        <li><strong>Canada:</strong> $16 per order. Ships First-Class Package International. Delivery 1–3 weeks.</li>
        <li><strong>Australia, Japan, New Zealand, South Korea, Mexico:</strong> $22 per order. Ships First-Class Package International. Delivery 1–4 weeks depending on customs.</li>
      </ul>

      <h3>Where we don't ship (yet)</h3>
      <p>
        We're not shipping to the UK or EU at the moment. Tax-compliance changes coming into effect in 2026 (EU's flat customs duty, UK VAT registration) require setup we haven't completed. We'll open those up once that's sorted.
      </p>

      <h2>Handling time</h2>
      <p>
        Orders ship within <strong>1–3 business days</strong> of purchase. During event season or holidays we may be a day or two slower — we'll let you know if your order falls into that window.
      </p>

      <h2>International orders — customs and duties</h2>
      <p>
        Customers outside the US are responsible for any import duties, taxes, or customs fees at delivery. These are charged by the destination country, not by us, and we can't predict the exact amount. Packages can take 2–4 weeks depending on customs processing.
      </p>
      <div className="jop-policy-callout">
        <strong>Canada:</strong> GST/PST and a small brokerage fee typically apply at delivery. Canada's de minimis threshold is $20 CAD, so most orders will incur some charge.
      </div>
      <div className="jop-policy-callout">
        <strong>Mexico:</strong> Customs delivery in Mexico can take 3–6 weeks. Packages valued over $50 USD may incur IVA (16%) plus a brokerage fee paid at delivery. We recommend planning for both.
      </div>

      <h2>Returns</h2>

      <h3>Stock merchandise (stickers, jewelry, shirts, prints)</h3>
      <p>
        Returnable within <strong>14 days</strong> of delivery, in unused and resalable condition. Email <a href="mailto:hello@thejoyofpancakes.com">hello@thejoyofpancakes.com</a> with your order number and we'll send instructions. Customers cover return shipping unless the item was defective or damaged in transit (see below).
      </p>

      <h3>Commissions + custom work</h3>
      <p>
        Commissioned pieces — pickup commissions, cake-topper centerpieces, preserved-pancake gifts, bulk orders, and any custom design — are <strong>non-returnable and non-refundable</strong>. Each piece is made specifically for you and can't be resold. We'll always share previews during production so you can flag concerns before the final work is made.
      </p>

      <h3>Damaged or lost in transit</h3>
      <p>
        If your order arrives damaged, <strong>send us a photo of the damage within 7 days of delivery</strong> and we'll send a replacement at no charge — no return required. If your tracking shows the package as lost in transit, email us and we'll either resend or refund.
      </p>

      <h2>Class cancellations</h2>
      <p>
        Classes and lessons get different windows depending on how hard the slot is to refill:
      </p>
      <ul>
        <li><strong>Public class sessions:</strong> full refund if you cancel at least <strong>48 hours</strong> before the class starts. Within 48 hours, your fee is forfeit.</li>
        <li><strong>1-on-1 private lessons:</strong> full refund if you cancel at least <strong>7 days</strong> before the scheduled lesson. 1-on-1 slots are harder to refill on short notice, which is why the window is longer.</li>
        <li>We can reschedule instead of refunding within either window if that works better for you — just ask.</li>
        <li>If we have to cancel, you get a full refund or a free reschedule.</li>
      </ul>

      <h2>Questions</h2>
      <p>
        Email <a href="mailto:hello@thejoyofpancakes.com">hello@thejoyofpancakes.com</a> — we read everything.
      </p>
    </PolicyPage>
  );
}
